export class OpponentsViewModel {
    public team: string = '';
    public opponents: string = '';
    public groupId: string = null;
    constructor(team: string, groupId: string = null) {
        this.team = team;
        this.groupId = groupId;
    }
    public addOpponent(opponent: string): void {
        if (this.opponents !== '') {
            this.opponents += ', ';
        }
        this.opponents += opponent === '' ? 'INGEN VALD' : opponent;
    }
}
